import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }
const DEEP = { deep: true }

export const CoursesRedux = createActions(
  {
    sendPersonRequest: ['data'],
    sendPersonSuccess: [''],
    sendPersonError: [''],
  },
  {
    prefix: 'COURSES_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = CoursesRedux
export const CoursesTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending:{
    fetching:false,
    error:null
  }
}, {
  get: true,
})

const sendPersonRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const sendPersonSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const sendPersonError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.sendPersonRequest]: sendPersonRequest,
  [Types.sendPersonSuccess]: sendPersonSuccess,
  [Types.sendPersonError]: sendPersonError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/CoursesRedux.js